export enum UserRole {
    BANNED = 0,
    DEACTIVATE = 1,
    GUEST = 2,
    MEMBER = 3,
    MODERATOR = 4,
    ADMINISTRATOR = 5,
    OWNER = 6
}

export function hasPermission(role: UserRole | undefined, expectedMinRole: UserRole): boolean {
    return role != undefined && role >= expectedMinRole;
}
